export default [
    { //问题留言列表
        path: '/messageBoard',
        name:'messageBoard',
        meta: { title: '意见反馈列表'},
        component: () => import('../../views/messageBoard/index.vue')
    },
    { //问题留言详情
        path: '/messageBoard/detail/:id',
        name:'messageBoardDetail',
        meta: { title: '问题留言详情'},
        component: () => import('../../views/messageBoard/detail.vue')
    }
]